<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [asyncSubmission]="true"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'betaalgegevens',
  }"
>
  <ng-template #content>
    @if (orderContent().splitIbanText) {
      @if (deviceInfo().isMobile) {
        <div *wlGenericRichText="orderContent().ibanTextMobile"></div>
      } @else {
        <div *wlGenericRichText="orderContent().ibanTextDesktop"></div>
      }
    } @else {
      <div *wlGenericRichText="orderContent().ibanText"></div>
    }

    <wl-text
      class="mt-1"
      wlAutocompleteDisabled
      [rendering]="rendering()"
      stepName="betaalgegevens"
      [step]="stepNumber()"
      fieldName="iban"
      [sendValue]="false"
      [valueConverter]="_ibanConverter"
      [formsControl]="formState().controls.iban"
      [placeholder]="orderContent().ibanPlaceholder"
      [label]="orderContent().ibanLabel"
      [floatingLabel]="!labelsShownAboveFields()"
    />
    @if (formState().controls.iban | isInvalid) {
      <wl-input-error
        wlAutomationId="transition-date-required-error"
        [messageField]="orderContent().ibanRequiredError"
        messageDescription="iban"
        [rendering]="rendering()"
        stepName="betaalgegevens"
        [step]="stepNumber()"
      ></wl-input-error>
    }
    @if (formState().controls.iban.errors['$ibanBlacklisted']) {
      <wl-info-card
        [message]="orderContent().ibanBlacklistedError"
        type="danger"
      ></wl-info-card>
    }
  </ng-template>
  <ng-template #summary>
    <p class="h6 mb-0">{{ orderContent().ibanLabel }}</p>
    <p wlCSMask>{{ formState().value.iban }}</p>
  </ng-template>
</wl-simple-progressive-form-card>
